import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import GiftWrappers from "./pages/GiftWrappers/GiftWrappers";

export const customPages = [
	{ moduleId: "7bd97c80-3bc6-4858-801c-81106e726fa2", path: "list", content: <GiftWrappers /> },
] as CustomPage[];
